// Marks orders paid with Stripe test keys (from the preview stack, which shares
// the production database). They're never printed: Gelato only gets drafts.
export function TestBadge() {
  return (
    <span
      title="Paid with Stripe test keys — not a real sale"
      style={{
        marginLeft: 6,
        padding: '1px 6px',
        borderRadius: 4,
        background: '#fef3c7',
        color: '#92400e',
        fontSize: 11,
        fontFamily: 'system-ui, sans-serif',
        fontWeight: 600,
        letterSpacing: 0.4,
      }}
    >
      TEST
    </span>
  );
}
